export default {
  textColor : 'white',
  borderTopForUPC: '15px solid #1B2025',
  marginTop: '15px',
  backgroundColor: '#27415E',
  reassuranceLinkMargin: '12px 0',
  font: {
    ubi: '"Ubisoft Sans Regular", Arial, sans-serif',
    ubiBold: '"Ubisoft Sans Bold", Arial, sans-serif',
    boldText :  '"Ubuntu","Ubisoft Sans Bold", sans-serif'
  },
};
